import React from "react";
import TextField from "@mui/material/TextField";

import TotalReceivingUnitsModal from "../TotalReceivingUnits/TotalReceivingUnitsModal";
import { getPluralForm } from "../TotalReceivingUnits/getTotalReceivingUnitsLabel";

export default function UnitsFormField({
  name,
  open,
  setOpen,
  title,
  value,
  label,
  typeLabel,
  quantityLabel,
  addLabel,
  onSubmit,
  typeKey,
  quantityKey,
  typeOptions,
}) {
  const handleToggle = () => {
    setOpen(v => !v);
  };

  const handleSave = list => {
    onSubmit(list);
    handleToggle();
  };

  function getTotalReceivingUnitsLabel(list) {
    return list
      .map(v => `${v[quantityKey]} ${getPluralForm(v[quantityKey], v[typeKey])}`)
      .join(", ");
  }

  return (
    <>
      <TextField
        fullWidth
        size="small"
        label={label}
        value={getTotalReceivingUnitsLabel(Array.isArray(value) ? value : [])}
        onClick={handleToggle}
      />
      {open && (
        <TotalReceivingUnitsModal
          title={title}
          value={value}
          onClose={handleToggle}
          onSave={handleSave}
          typeLabel={typeLabel}
          quantityLabel={quantityLabel}
          addLabel={addLabel}
          typeKey={typeKey}
          quantityKey={quantityKey}
          typeOptions={typeOptions}
        />
      )}
    </>
  );
}
